export enum Request {
  I18N = `
  query($locale: I18NLocaleCode) {
    nav(locale: $locale) {
      items {
        label
        slug
        isQuickLink
      }
    }
    company(locale: $locale) {
      name
      logo {
        url
      }
      address {
        street
        zipcode
        city
        country
      }
      siret
      vat
      ape
      capital
    }
    social(locale: $locale) {
      linkedin
      github
      twitter
      instagram
      facebook
    }
    homePage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      presentation {
        videoID
        platform
      }
      jumbotron {
        ctas {
          label
          href
        }
      }
      spirit {
        content
      }
      offers {
        ctaLabel
      }
    }
    offersPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      groups {
        ctaLabel
      }
      card {
        ctaLabel
      }
    }
    offerPage(locale: $locale) {
      characteristics {
        duration {
          label
          image {
            url
          }
        }
        budget {
          label
          image {
            url
          }
        }
        team {
          label
          image {
            url
          }
        }
      }
      details {
        title
        deliverables {
          title
          image {
            url
          }
        }
        options {
          title
          image {
            url
          }
        }
        commitments {
          title
          image {
            url
          }
        }
      }
      showcases {
        title
      }
    }
    spiritPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      values {
        content
        items {
          title
          description
          image {
            url
          }
        }
      }
      profiles {
        content
        profiles (pagination: { page: 1, pageSize: 10000 }) {
          seo {
            title
            description
            image {
              url
            }
            icons {
              url
            }
          }
          name
          icon {
            url
          }
          color
          backgroundColor
        }
      }
      career {
        content
        profiles (pagination: { page: 1, pageSize: 10000 }) {
          seo {
            title
            description
            image {
              url
            }
            icons {
              url
            }
          }
          name
          icon {
            url
          }
          color
          backgroundColor
        }
      }
      advantages {
        content
        items {
          title
          description
          image {
            url
          }
        }
        cta {
          label
          href
        }
      }
    }
    contact(locale: $locale) {
      card {
        cta {
          label
        }
        content {
          title
          description
          image {
            url
          }
          calendly
        }
      }
      team {
        seo {
          title
          image {
            url
          }
          icons {
            url
          }
        }
        consent {
          imageDisplay
          nameDisplay
        }
        displayProfile {
          family {
            backgroundColor
            name
            color
            icon {
              url
            }
          }
        }
      }
      items {
        label
      }
    }
    teamsPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      teams {
        content
        teams (pagination: { page: 1, pageSize: 10000 }) {
          lastName
          firstName
          slug
          jobTitle
          consent {
            imageDisplay
            nameDisplay
          }
          seo {
            title
            description
            image {
              url
            }
          }
          displayProfile {
            family {
              backgroundColor
              name
              color
              icon {
                url
              }
            }
          }
        }
      }
    }
    teamPage(locale: $locale) {
      empty
      personality
      posts
      testimonials
    }
    clientsPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      clients {
        content
        clients (pagination: { page: 1, pageSize: 10000 }) {
          seo {
            title
            description
            image {
              url
            }
          }
          website
        }
      }
      testimonials {
        content
        testimonials (pagination: { page: 1, pageSize: 10000 }) {
          name
          job
          comment
          avatar {
            url
          }
        }
      }
      partners {
        content
        partners (pagination: { page: 1, pageSize: 10000 }) {
          seo {
            title
            description
            image {
              url
            }
          }
          website
        }
      }
    }
    jobsPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      emptyContent
    }
    jobPage(locale: $locale) {
      offer {
        content {
          title
          description
          image {
            url
          }
        }
        cta {
          label
          href
        }
      }
      skills {
        title
      }
      spirit {
        content {
          title
          description
          image {
            url
          }
        }
        cta {
          label
          href
        }
      }
    }
    agenciesPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      card {
        calendlyLabel
        webSiteLabel
      }
    }
    blogsPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      emptyContent
    }
    labsPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      emptyContent
    }
    showcasesPage(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      emptyContent
    }
    showcasePage(locale: $locale) {
      project
      offer
      images
    }
  }
  `,
  BLOGS = `
  query($locale: I18NLocaleCode, $sort: [String]) {
    blogs(locale: $locale, sort: $sort) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      slug
      publication
    }
  }
  `,
  BLOG = `
  query($locale: I18NLocaleCode, $slug: String!) {
    blogBySlug(locale: $locale, slug: $slug) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      slug
      publication
      content
      team {
        firstName
        lastName
        slug
        consent {
          imageDisplay
          nameDisplay
        }
        displayProfile {
          family {
            backgroundColor
            icon {
              url
            }
            name
          }
        }
        seo {
          description
          image {
            url
          }
        }
      }
    }
  }
  `,
  TEAM = `
  query ($locale: I18NLocaleCode, $slug: String!) {
    teamBySlug(locale: $locale, slug: $slug) {
      lastName
      firstName
      slug
      jobTitle
      consent {
        imageDisplay
        nameDisplay
      }
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      personality {
        name
        code
        description
        image {
          url
        }
      }
      testimonials {
        name
        job
        avatar {
          url
        }
        comment
        date
      }
      blogs {
        seo {
          title
          description
          image {
            url
          }
        }
        slug
      }
      displayProfile {
        family {
          backgroundColor
          name
          seo {
            image {
              url
            }
          }
          icon {
            url
          }
        }
      }
    }
  }
  `,
  SHOWCASES = `
  query($locale: I18NLocaleCode) {
    showcases(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      slug
    }
  }
  `,
  SHOWCASE = `
  query($locale: I18NLocaleCode, $slug: String!) {
    showcaseBySlug(locale: $locale, slug: $slug) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      client {
        name
        seo {
          title
          description
          image {
            url
          }
        }
      }
      offer {
        seo {
          title
          description
          image {
            url
          }
          icons {
            url
          }
        }
        slug
        duration
        budget
        team
      }
      slug
      url
      budget
      content
      images {
        url
      }
    }
  }
  `,
  JOBS = `
  query($locale: I18NLocaleCode) {
    jobs(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      slug
    }
  }
  `,
  JOB = `
  query($locale: I18NLocaleCode, $slug: String!) {
    jobBySlug(slug: $slug, locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      technologies {
        name
        logo {
          url
        }
      }
    }
  }
  `,
  AGENCIES = `
  query {
    agencies {
      documentId
      address {
        street
        zipcode
        city
        country
      }
      contact {
        calendly
        webSite
      }
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      theme {
        logo {
          square {
            url
          }
        }
      }
    }
  }
  `,
  LABS = `
  query($locale: I18NLocaleCode) {
    labs(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      link
    }
  }
  `,
  OFFER_GROUPS = `
  query($locale: I18NLocaleCode) {
    offerGroups(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      offers {
        seo {
          title
          description
          image {
            url
          }
          icons {
            url
          }
        }
        slug
        duration
        budget
        team
      }
    }
  }
  `,
  OFFERS = `
  query($locale: I18NLocaleCode) {
    offers(locale: $locale) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
    }
  }
  `,
  OFFER = `
  query ($locale: I18NLocaleCode, $slug: String!) {
    offerBySlug(locale: $locale, slug: $slug) {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      content
      duration
      budget
      team
      commitments {
        name
      }
      options {
        name
      }
      deliverables {
        name
      }
      showcases {
        seo {
          title
          description
          image {
            url
          }
        }
        slug
      }
    }
  }
  `,
  PROFILES = `
  query {
    profileFamilies {
      seo {
        title
        description
        image {
          url
        }
        icons {
          url
        }
      }
      name
      icon {
        url
      }
      color
      backgroundColor
    }
  }
  `,
}
